import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UserdataService {
  data:any
  constructor(private http: HttpClient, private dataService: DataService) { }

  getUsers() {
    return this.dataService.getRecord('/api/users');
  };

  getUserById(userid: number) {
    return this.dataService.getRecord('/api/user/getUser/' + userid);
  }

  getUserMenu(userId: number) {
    return this.dataService.getRecord('/api/getuserpages/' + userId);
  };

  getSearchWithStatusType(searchItem: any) {
    return this.dataService.getRecord('/api/Application/getSearchWithStatusType/' + searchItem);
  }

  forgotPassword(email, baseurl) {
    return this.dataService.getRecord('/api/Login/ForgetPassword/?Email=' + email + '&BaseUrl=' + baseurl);
  };

  resetPassword(passwordresetdetail: any) {
    return this.dataService.post('/api/Login/ResetPassword', passwordresetdetail);
  };

  // activateUser(querystring: any) {
  //   return this.dataService.post('/api/Login/activateUser/' + querystring);
  // };

  changePassword(changePasswordDetails: any): Observable<any> {
    return this.dataService.post('/api/Login/ChangePassword', changePasswordDetails);
  }

  threeMonthOncePasswordChange(changePasswordDetails: any) {
    return this.dataService.post('/api/Login/ThreeMonthOncePasswordChange', changePasswordDetails);
  }
  getTechnicianList() {
    return this.dataService.getRecord('/api/gettechnicianlist');
  }
  /* commented in API 
  getTechnicianList() {
    return this.dataService.getLookupData('/api/gettechnicianlist');
  }

  getCenterList() {
    return this.dataService.getLookupData('/api/spcenter/getCenterList');
  }

  getCounterList() {
    return this.dataService.getLookupData('/api/spcenter/getCounterList');
  }
  */

  getUserDetails(searchText: any) {
    return this.dataService.getRecord('/api/user/getUserDetails/?searchText=' + searchText);
  }

  getUserDetailsByCustomerReference(searchText: any) {
    return this.dataService.getRecord('/api/user/getUserDetailsByCustomerReference/?searchText=' + searchText);
  }

  getAmendCustomer(userEmailId: number) {
    return this.dataService.getRecord('/api/user/getAmendCustomer/?userEmailId=' + userEmailId);
  };

  submitAmendCustomer(querystring: any) {
    return this.dataService.post('/api/user/submitAmendCustomerv2', querystring);
  };

  resetPasswordForAmendCustomer(userEmailId: string, isFromAdminLogin: boolean)  {
    return this.dataService.post('/api/user/resetPassword/?userEmailId=' + userEmailId + '&isFromAdminLogin=' + isFromAdminLogin, this.data);
  };

  clearBalanceForAmendCustomer(userEmailId: number, referenceNumber: any) {
    return this.dataService.post('/api/user/clearBalance/?userEmailId=' + userEmailId + '&referenceNumber=' + referenceNumber, this.data);
  };

  getAmendAddress(referenceNumber: any) {
    return this.dataService.getRecord('/api/user/getAmendAddress/?referenceNumber=' + referenceNumber);
  };

  submitAmendAddress(querystring: any) {
    return this.dataService.post('/api/user/submitAmendAddress', querystring);
  };

  getUserDetailsRemoveCustomer(userEmailId: number) {
    return this.dataService.getRecord('/api/user/getUserDetailsRemoveCustomer/?userEmailId=' + userEmailId);
  };

  getApplicationDetailsRemoveCustomer(userEmailId: number) {
    return this.dataService.getRecord('/api/user/getApplicationDetailsRemoveCustomer/?userEmailId=' + userEmailId);
  };

  // removeCustomerbyEmail(userEmailId: number) {
  //   return this.dataService.post('/api/user/removeCustomerbyEmail/?userEmailId=' + userEmailId);
  // };

  getBankingDetailsBySearch(searchQuery: any) {
    return this.dataService.getRecord('/api/user/getBankingDetailsBySearch/?searchQuery=' + searchQuery);
  };
  getUserIdBySearch(searchQuery: any) {
    return this.dataService.getRecord('/api/user/getUserIdBySearch/?searchQuery=' + searchQuery);
  };
  checkEmailValidation(email: any) {
    return this.dataService.getRecord('/api/user/checkEmailValidation/?email=' + email);
  };
  checkEmailIdForReferral(email: any) {
    return this.dataService.getRecord('/api/user/checkEmailIdForReferral/?email=' + email);
  };
  saveCustomerReferral(customerReferralDetails: any) {
    return this.dataService.post('/api/user/saveCustomerReferral', customerReferralDetails);
  };
  checkCustomerCompleted() {
    return this.dataService.getRecord('/api/user/checkCustomerCompleted');
  }

  GetReferralDetails() {
    return this.dataService.getRecord('/api/User/getLuckyCustomers');
  }
  getUserIdforCustomerReferral(id: number) {
    return this.dataService.getRecord('/api/user/getUserIdforCustomerReferral/?id=' + id);
  }
  savePreferedCommunicationType(preferedType: any, email: any) {
    return this.dataService.getRecord('/api/user/savePreferedCommunicationType/?preferedType=' + preferedType + '&email=' + email);
  }
  getAmendBillingInformation(referenceNumber: any) {
    return this.dataService.getRecord('/api/user/getAmendBillingInformation/?referenceNumber=' + referenceNumber);
  };
  deleteHCUser(userId: number) {
    return this.dataService.getRecord('/api/user/deleteHCUser/' + userId);
  }

  getBalancePaymentInformation() {
    return this.dataService.getRecord('/api/user/getBalancePaymentInformation');
  };

  updateIsBalancePayment() {
    return this.dataService.getRecord('/api/user/updateIsBalancePayment');
  }

  IsUserHaveOutstandingBalance() {
    return this.dataService.getRecord('/api/user/isOutstandingBalance');
  }

  getVumatelEvents(number: any) {
    return this.dataService.getRecord('/api/application/getVumatelEvents/' + number);
  }

  getVumatelEventsByID(ID: number) {
    return this.dataService.getRecord('/api/application/getVumatelEventsByID/' + ID);
  }

  getUsrAffectByVumatlEvntID(ID: number) {
    return this.dataService.getRecord('/api/application/getUsrAffectByVumatlEvntID/' + ID);
  }

   GetReferralDetailsbyFilter(data: any) {
    return this.dataService.getRecordWithParams('/api/user/GetReferralDetailsbyFilter', data);
  }

   MarkReferralAsPaid(referralId: any) {
    return this.dataService.getRecord('/api/user/MarkasPaidbyId/'+ referralId);
  }

    ImportReferralPaidUsers(data: any) {
    return this.dataService.post('/api/user/ImportReferralPaidUsers',data);
  }
}
